import { LanguageCodeEnum } from '@/shared/config/common/constants/lang';

const getBaseUrl = () => {
  const env = process.env.NEXT_PUBLIC_ENV;

  if (env === 'local') {
    return 'http://localhost:3000';
  }

  if (env === 'dev') {
    return 'https://dev.idoctor.kz';
  }

  return 'https://idoctor.kz';
};

export const getHrefLang = (code: LanguageCodeEnum, pathname: string) => {
  const baseUrl = getBaseUrl();

  if (code === LanguageCodeEnum.RU) {
    return `${baseUrl}${pathname.replace('/kk', '')}`;
  }
  return `${baseUrl}/kk${pathname.replace('/kk', '')}`;
};
